import { render, staticRenderFns } from "./scroll-bar-page.vue?vue&type=template&id=1974eabf&"
import script from "./scroll-bar-page.vue?vue&type=script&lang=js&"
export * from "./scroll-bar-page.vue?vue&type=script&lang=js&"
import style0 from "./scroll-bar-page.vue?vue&type=style&index=0&id=1974eabf&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports